import React from "react"
import Lottie from "react-lottie"

import animationData from "../../assets/bb_site_footer.json"

export const FooterAnimation = (props) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "canvas",
    rendererSettings: {},
  }

  return <Lottie isPaused={props.isPaused} options={defaultOptions} isClickToPauseDisabled />
}
